import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

export async function logAppError(
  action: string,
  errorMessage: string,
  metadata: {
    userId?: string;
    userEmail?: string;
    organisationId?: string;
    courseId?: string;
    route?: string;
  } = {}
) {
  try {
    await addDoc(collection(db, 'app_errors'), {
      ...metadata,
      action,
      errorMessage,
      timestamp: serverTimestamp(),
      deviceType: typeof navigator !== 'undefined' && /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(navigator.userAgent) ? 'mobile' : 'desktop',
      browser: typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown',
    });
  } catch (err) {
    console.error("Failed to log app error to Firestore:", err);
  }
}
